import { Outlet } from 'react-router-dom';
import { Header } from '../../pages/blog/container/Header';
import { Breadcrumbs } from '../../hooks/breadcrumbs';

import styles from '../ContactForm/ContactForm.module.css';

const Layout = () => {
  return (
    <main>
      <Header />
      <Breadcrumbs />
      <div className={styles.blogSection}>
        <Outlet />
      </div>
    </main>
  );
};

export default Layout;
